import { convertUnit, normalizeMemoryUnit, type MemoryUnit } from '@cast/utils';

type FleetMemoryMetrics = {
  connected: number;
  discovered: number;
  used: number;
  unit: MemoryUnit;
  discoveredUnit: `/${MemoryUnit}`;
  connectedTiB: number;
  discoveredTiB: number;
  usedTiB: number;
};

type BuildFleetMemoryMetricsArgs = {
  connectedGiB: number;
  discoveredGiB?: number;
  usedGiB: number;
};

export const buildFleetMemoryMetrics = ({
  connectedGiB,
  discoveredGiB = 0,
  usedGiB,
}: BuildFleetMemoryMetricsArgs): FleetMemoryMetrics => {
  const totalGiB = connectedGiB + discoveredGiB;
  const { unit } = normalizeMemoryUnit({
    amount: totalGiB,
    unit: 'GiB',
  });

  return {
    connected: connectedGiB,
    discovered: discoveredGiB,
    used: usedGiB,
    unit,
    discoveredUnit: `/${unit}`,
    connectedTiB: convertUnit(connectedGiB, 'GiB', unit),
    discoveredTiB: convertUnit(discoveredGiB, 'GiB', unit),
    usedTiB: convertUnit(usedGiB, 'GiB', unit),
  };
};
